<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
  @import "../node_modules/material-design-iconic-font/dist/css/material-design-iconic-font.min.css";
  @import "../node_modules/animate.css/animate.min.css";
  @import "../node_modules/select2/dist/css/select2.min.css";
  @import "../node_modules/sweetalert2/dist/sweetalert2.min.css";
  @import "../node_modules/jquery.scrollbar/jquery.scrollbar.css";
  @import "./assets/vendors/materialdesign/css/app.css";
</style>

<style lang="scss">

  html {
    position: relative;
  }

  section {
    margin: 10rem 1rem;
  }

  .field-label {
    text-align: right;
    margin-top: 0.7rem;
  }

  .field-value {
    font-size: 1rem;
    color: #495057;
    margin-top: 0.7rem;
  }

  @media (max-width: 570px) {
    .field-label {
      text-align: left;
    }
  }

  /* Breakpoint XL */
  @media (min-width: 1600px) {
    section {
      margin-left: 20rem;
      margin-right: 20rem;
    }
  }

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  .rotating {
    -webkit-animation: rotating 1s linear infinite;
    -moz-animation: rotating 1s linear infinite;
    -ms-animation: rotating 1s linear infinite;
    -o-animation: rotating 1s linear infinite;
    animation: rotating 1s linear infinite;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue